<template>
  <page-loading-wrapper :is-loading="fetchingGroups"
                        format-classes="mb-4"
                        loading-message="Fetching available members"
  >
    <div v-if="availableGroupMembers.length > 0 && isAdminOrManagerOfCurrentGroup" class="row">
      <div class="col-12">
        <div id="card-add-group-members" class="card">
          <div class="card-body">
            <h3 class="card-title">Group Members</h3>
            <pipeline-status-alert
              :pipeline-response-name="responseName"
              for-type="group" for-role="member">
            </pipeline-status-alert>
            <label for="groupMembersList">Add Groups as Members</label>
            <div class="row">
              <div class="col-md-6">
                <label class="sr-only" for="groupMemberFilter">Filter by Group UUGID</label>
                <div class="input-group mb-2">
                  <input v-model="groupMemberFilter"
                         type="text"
                         class="form-control"
                         id="groupMemberFilter"
                         placeholder="Filter by UUGID">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" @click="groupMemberFilter = ''" >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <form @submit.prevent="requestAddGroupMembers">
              <div id="groupMembersList" class="row scroll-container">
                <div class="form-group col-12 col-sm-6 col-lg-3"
                     v-for="groupMember in filteredAvailableGroups"
                     :key="groupMember">
                  <div class="custom-control custom-checkbox">
                    <label :for="'chk-groupMember-'+groupMember" class="sr-only">{{groupMember}}</label>
                    <!--suppress HtmlFormInputWithoutLabel lint checks do not pick up the dynamic id-->
                    <input class="custom-control-input"
                           type="checkbox"
                           v-model="$v.addGroupMembersForm.members.$model"
                           :value="groupMember"
                           :id="'chk-groupMember-'+groupMember"
                           :disabled="addGroupMembersForm.submitting">
                    <label class="custom-control-label" :for="'chk-groupMember-'+groupMember">
                      {{groupMember}}
                    </label>
                  </div>
                </div>
              </div>
              <button id="btn-add-grp-members"
                      type="submit"
                      class="btn btn-primary"
                      :disabled="$v.addGroupMembersForm.members.$invalid || addGroupMembersForm.submitting === true">
                {{addGroupMembersForm.submitting === true ? 'Submitting...' : 'Add Selected Groups'}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </page-loading-wrapper>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { groupsFetch, groupsMixin, auth } from '../../util/groups-mixin';
import PipelineStatusAlert from '../PipelineStatusAlert';
import PageLoadingWrapper from '../slots/PageLoadingWrapper';

export default {
  name: 'AddGroupMembers',
  mixins: [groupsFetch, groupsMixin, auth],
  props: {
    responseName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      addGroupMembersForm: {
        members: [],
        submitting: false,
      },
      groupMemberFilter: '',
    };
  },
  components: {
    'pipeline-status-alert': PipelineStatusAlert,
    'page-loading-wrapper': PageLoadingWrapper,
  },
  computed: {
    /*
     * Groups that the current user can add as members of other groups.
     * They must have one of the following roles: [admin, manager, contact]
     */
    updatableGroups() {
      return this.$store.state.managedGroups
        .filter(group => (group.managedGroup.isAdmin || group.managedGroup.isManager || group.managedGroup.isContact));
    },
    availableGroupMembers() {
      return this.updatableGroups
        .map(groupAdminOrManagerOf => groupAdminOrManagerOf.key)
        .filter(key =>
          !this.groupMembers
            .map(groupMember => groupMember.uugid)
            .includes(key) && key !== this.managedGroup.uugid);
    },
    filteredAvailableGroups() {
      if (!this.groupMemberFilter) {
        return this.availableGroupMembers;
      }
      return this.availableGroupMembers.filter(uugid => uugid.includes(this.groupMemberFilter));
    },
    groupMembers() {
      return this.$store.getters.groupMembers(this.managedGroup, 'group');
    },
  },
  methods: {
    resetAddGroupMembersForm() {
      this.addGroupMembersForm.members = [];
      this.addGroupMembersForm.submitting = false;
      this.$nextTick(() => { this.$v.$reset(); });
    },
    requestAddGroupMembers() {
      this.$store.dispatch('clearPipelinedStateResponse', 'addGroupMembersResponse');
      /* validate form */
      this.$v.$touch();
      /* if form isn't invalid */
      if (!this.$v.addGroupMembersForm.members.$invalid) {
        this.addGroupMembersForm.submitting = true;
        this.$store.dispatch('batchModifyGroupRoles',
          {
            uugid: this.managedGroup.uugid,
            type: 'members',
            kind: 'group',
            roleIds: this.addGroupMembersForm.members,
            modify: 'add',
            responseToSet: 'addGroupMembersResponse',
          })
          .then(() => {
            document.getElementById('groupMembersList').scrollTop = 0;
            this.scrollToElement('card-add-group-members');
          })
          .finally(() => {
            this.resetAddGroupMembersForm();
          });
      }
    },
  },
  validations: {
    addGroupMembersForm: {
      members: {
        required,
      },
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/add-members/AddGroupMembers.vue